<div class="errors">
  <p *ngFor="let err of errorStrings">{{ errorsMap[err] }}</p>
</div>
